import { SMSLinkShorteningContextProvider } from './SMSLinkShorteningContextProvider';
import { SMSPreviewContextProvider } from './SMSPreviewContextProvider';
import { SMSSendersQueryContextProvider } from './SMSSendersQueryContextProvider';

export const SMSContext = ({ children }: { children: React.ReactNode }) => (
  <SMSSendersQueryContextProvider>
    <SMSLinkShorteningContextProvider>
      <SMSPreviewContextProvider>{children}</SMSPreviewContextProvider>
    </SMSLinkShorteningContextProvider>
  </SMSSendersQueryContextProvider>
);
